<template>
  <div class="gst-pop-outer">
    <div v-if="!showTerms">
      <div class="gst-popup-header">
        <div class="cart-title-text">Order Confirmation</div>
        <v-icon
          class="mdi-close-right"
          @click="onClose({ ...data, status: false })"
          >mdi-close</v-icon
        >
      </div>
      <div class="gst-popup" >
        <div class="price-row-pop" v-for="prod in data.prodObj" :key="prod.id">
          <div class="detail-2-line">
            <div class="left-text-style">{{ prod.group_name === 'SUBSCRIPTION' ? `Boost Up : ${prod.name}` : prod.group_name}}</div>
            <div v-if="prod.name" class="left-text-style">
              {{ prod.group_name === 'SUBSCRIPTION' ?  `(Valid upto- ${getFormatedDate(prod.valid_upto)} )` : prod.name }}
            </div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span>{{ prod.price }}
          </div>
        </div>

        <div class="price-row-pop">
          <div class="detail-2-line">
            <div class="left-text-style-gray">Total:</div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span
            >{{ data.priceDetails.total_product_amount }}
          </div>
        </div>
        <div class="price-row-pop">
          <div class="detail-2-line">
            <div class="left-text-style-gray">GST:</div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span
            >{{ (data.priceDetails.gst_amount).toFixed(2) }}
          </div>
        </div>
        <div class="price-row-pop">
          <div class="detail-2-line">
            <div class="left-text-style-gray">Grand Total:</div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span
            >{{ (data.priceDetails.total_amount_with_gst).toFixed(2)}}
          </div>
        </div>
        <div class="price-row-pop" v-if="discountAmount">
          <div class="detail-2-line">
            <div class="left-text-style-gray">Discount:</div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span>{{ discountAmount.toFixed(2) }}
          </div>
        </div>

        <div class="price-row-pop after-dis" v-if="discountAmount">
          <div class="detail-2-line">
            <div class="left-text-style">After Discount:</div>
          </div>
          <div class="left-text-style cp3-left-align">
            <span class="price-title">&#8377; </span
            >{{ totalAfterDiscount.toFixed(2) }}
          </div>
        </div>
        <div class="price-row-pop-input">
          <v-text-field
            v-model="couponCode"
            label="Have a discount code?"
            :counter="10"
            @keydown.space.prevent
            dense
            outlined
            hide-details
          >
            <template v-slot:append>
              <span
                v-if="couponCode.length && !isCouponCodeValid"
                class="code-span-btn"
                color="primary"
                text
                @click="verifyCouponCode()"
                >Apply</span
              >
              <span
                v-if="couponCode.length && isCouponCodeValid"
                class="code-span-btn"
                color="primary"
                text
                @click="clearCode(true)"
                >Remove</span
              >
            </template>
          </v-text-field>
          <InputError :data="error.couponCode" />
        </div>
        <div class="price-row-pop-input">
          <v-text-field
            v-model="gstNumber"
            label="Have a GST Number?"
            dense 
            outlined 
            hide-details
          >
            <template v-slot:append>
              <span
                v-if="gstNumber.length && isGstNumberValid"
                class="code-span-btn"
                color="primary"
                text
                @click="applyGstNumber()"
                >Apply</span
              >
              <span
                v-if="gstNumber.length && !isGstNumberValid"
                class="code-span-btn"
                color="primary"
                text
                @click="clearCode()"
                >Remove</span
              >
            </template>
          </v-text-field>
          <InputError :data="error.gstNumber" />
        </div>
        <div class="check-aggrement">
          <div class="check-cust">
            <v-checkbox v-model="isAgreed"></v-checkbox>
          </div>
          <div class="agree-text">I agree with the</div>
          <div
            class="terms-text"
            @click="showTerms = true"
          >
            Terms and Conditions.
          </div>
        </div>
        <div class="cart-btn new-cr-cart">
          <v-btn
            :disabled="!isAgreed"
            color="primary"
            @click="handlePayNow()"
            class="right-btn cust-btn pay-now-btn"
            >Pay Now &#8377;{{
              (isCouponCodeApplied ? totalAfterDiscount.toFixed(2) : (data.priceDetails.total_amount_with_gst).toFixed(2))
            }}</v-btn
          >
        </div>
      </div>
    </div>
    
    <div v-else class="px-4 py-4">
      <div>
        <v-icon class="float-right" @click="showTerms = false">mdi-close</v-icon>
      </div>
      <h5>Terms and Conditions</h5>
      <div class="terms-scroll">
        <ol>
          <li>
            All the Premium Papers available in this platform contains Questions in
            the English language only.
          </li>
          <li>
            You can answer any of the tests that you purchase at any date or time till
            st upcoming 31 May. Your access to the papers shall be disabled automatically
            past this date.
          </li>
          <li>
            The questions provided in this platform are taken from the official websites of
            the respective examination or from other reliable sources when official paper is
            not available. This platform is not liable for accuracy of the questions, answers
            in such cases as this platform only serves the purpose of simulating the exams
            held earlier.
          </li>
          <li>
            The Interface used to answer the examinations may not replicate the actual
            examination interface.
          </li>
          <li>
            The All India Rank predicted after your submission of a test is based on the
            extrapolation of the data of marks vs rank available for the respective exam and
            may or may not be accurate despite our best efforts.
          </li>
        </ol>
      </div>
      <div class="text-center">
        <v-btn centered color="primary" @click="showTerms = false">OK</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InputError from "../../InputError.vue";
import moment from "moment";
import constants from "@/utils/constants.js";
export default {
  name: "GstChargesPopUp",
  props: ["data", "onClose", "status"],
  data: function() {
    return {
      typetimeout: null,
      couponCode: "",
      gstNumber: "",
      discountAmount: "",
      discountPercentage: "",
      totalAfterDiscount: "",
      error: {
        couponCode: {
          type: null,
          message: "",
        },
        gstNumber: {
          type: null,
          message: "Sorry! This not a valid GST number.",
        },
      },
      isAgreed: false,
      isCouponCodeValid: false,
      isCouponCodeApplied: false,
      isGstNumberValid: false,
      isGstNumberApplied: false,
      showTerms: false,
    };
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  methods: {
    ...mapActions({
      verifyCoupon: "userStore/verifyCoupon",
      applyCoupon: "userStore/applyCoupon",
      createPackageOrder: "userStore/createPackageOrder",
    }),
    verifyCouponCode() {
      let product_ids = [];
      this.data.prodObj.forEach((pkg) => {
        product_ids.push(pkg.id);
      });
      let reqData = {
        coupon: this.couponCode,
        product_ids: product_ids,
      };
      this.verifyCoupon(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.error.couponCode.type = 'null';
          this.applyCoupon(reqData)
            .then((response) => {
              if (response) {
                let maxAmtMsg = response.discount > response.coupon.coupon_amount ? `(Max. Amt. ₹${response.discount})` : ''
                this.$root.showLoader = false;
                this.error.couponCode.type = 'success';
                this.error.couponCode.message = `Congrats! You got a ${response.coupon.discount_percentage}% discount.`+ maxAmtMsg;
                this.discountAmount = response.discount;
                this.discountPercentage = response.coupon.discount_percentage;
                this.totalAfterDiscount = response.total_amount_with_gst;
                this.isCouponCodeApplied = true;
              }
            })
            .catch((e) => {
              console.log(e);
            }); 
          this.isCouponCodeValid = true;          
        })
        .catch((err) => {
          let errData = err && err.data && err.data.errors;
          if (errData && errData.length) {
            this.$root.showLoader = false;
            this.error.couponCode.type = "error";
            this.error.couponCode.message = errData[0].message;
            this.isCouponCodeApplied = false;
            this.isCouponCodeValid = true;
          }
        });
    },
    clearCode(isClearCode) {
      if (isClearCode) {
        this.couponCode = "";
        this.discountAmount = "";
        this.error.couponCode.type = null;
        this.isCouponCodeValid = false;
        this.isCouponCodeApplied = false;
      } else {
        this.gstNumber = "";
        this.error.gstNumber.type = null;
        this.isGstNumberValid = false;
        this.isGstNumberApplied = false;
      }
    },
    validate(isCode) {
      let isValid = true;
      isCode ? this.error.couponCode.type = null : this.error.gstNumber.type = null;
      this.error.gstNumber.type = null;
      if (this.couponCode && this.couponCode.length > 25) {
        this.error.couponCode.type = "error";
        isValid = false;
      }
      if (
        this.gstNumber &&
        this.gstNumber.length &&
        !this.isValidGST(this.gstNumber)
      ) {
        this.error.gstNumber.type = "error";
        isValid = false;
      }
      if(this.gstNumber && !isCode){
        this.isGstNumberValid = isValid;
      }
      return isValid;
    },
    getFormatedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    isValidGST(num) {
      let regex = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}" + "[A-Z]{1}[1-9A-Z]{1}" + "Z[0-9A-Z]{1}$"
      );
      if (regex.test(num)) {
        return true;
      }
      return false;
    },
    applyGstNumber(){
      this.isGstNumberValid = false;
      this.isGstNumberApplied = true;
    },
    getMasterPyqProductId() {
      if (this.user && this.user.batch_name === '2026') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE26;
        } else {
          return constants.MODULES.MASTERPYQNEET26;
        }
      } else if (this.user && this.user.batch_name === '2027') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE27;
        } else {
          return constants.MODULES.MASTERPYQNEET27;
        }
      } else if (this.user && this.user.batch_name === '2028') {
        if ((this.user.center_name === 'JEE' || this.user.center_name === "Engineering")) {
          return constants.MODULES.MASTERPYQJEE28;
        } else {
          return constants.MODULES.MASTERPYQNEET28;
        }
      }
    },
    submitPayment(paymentData) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = paymentData.pg_url;
      
      const { pg_url, ...formData } = paymentData;
      
      Object.keys(formData).forEach(key => {
        if (formData[key] !== undefined) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = formData[key];
          form.appendChild(input);
        }
      });
      
      document.body.appendChild(form);
      form.submit();
    },
    handlePayNow() {
      this.$root.showLoader = true;
      let product_ids = [];
      this.data.prodObj.forEach((pkg) => {
        product_ids.push(pkg.id);
      });
      const reqData = {
        product_ids: product_ids,
        success_redirect: window.location.href.split("?")[0],
        failure_redirect: window.location.href.split("?")[0],
        coupon: this.isCouponCodeApplied ? this.couponCode : "",
        gst_number: this.isGstNumberApplied ? this.gstNumber : ""
      };

      this.createPackageOrder(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          const order = response.order;
          const paymentData = {
            key: order.key,
            txnid: order.tx_id + "",
            amount: order.amount,
            firstname: this.user.name,
            email: this.user.email,
            phone: this.user.phone,
            productinfo: "" + order.productsForPurchase,
            surl: order.surl,
            furl: order.furl,
            hash: order.hash,
            mode: "dropout",
            udf1: order.udf1,
            udf2: order.udf2,
            udf3: order.udf3,
            udf5: "",
            pg_url: order.pg_url
          };
          this.submitPayment(paymentData);
        })
        .catch((err) => {
          this.$root.showLoader = false;
          this.$toasted.error('Failed to create order');
        });
    }
  },
  watch:{
    status(val){
      this.error.couponCode.type = null;
      this.error.gstNumber.type = null;
      if(!val){
        this.couponCode = '';
        this.gstNumber = '';
        this.discountAmount = "";
        this.error.couponCode.type = null;
        this.isCouponCodeValid = false;
        this.isCouponCodeApplied = false;
      }
    }
  },
  components: { InputError },
};
</script>
